import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { TravelTwoIcon } from '@repo/ui/icons'
import InnerBox from '@repo/ui/inner-box'

import useEnrollment from '../../../../lib/hooks/use-enrollment'
import ClientSpacePageTitle from '../client-space-page-title'
import ClientEnrollmentCenterCard from './client-enrollment-center-card'

const ClientCenterContactWithoutTransport = () => {
  const { enrollment } = useEnrollment()

  return (
    <div className="flex flex-col gap-4">
      <ClientSpacePageTitle
        icon={<TravelTwoIcon color={tailwindColors.primary.dark.DEFAULT} />}
        title="RDV lieu de séjour"
      />
      {enrollment.mainProposition?.journey.date.product.noTransportGuide && (
        <InnerBox className="rounded-lg py-3 px-4 bg-white-hover">
          <div
            dangerouslySetInnerHTML={{
              __html: enrollment.mainProposition?.journey.date.product.noTransportGuide
            }}
          />
        </InnerBox>
      )}
      {/* <ClientEnrollmentTripInformationWarningCard /> */}
      {enrollment.enrollmentCenter?.center && (
        <ClientEnrollmentCenterCard
          enrollmentId={enrollment.id}
          data={enrollment.enrollmentCenter?.center}
        />
      )}
    </div>
  )
}

export default ClientCenterContactWithoutTransport
